export const bulletList = {
	group: "block list",
	content: "listItem+",
	attrs: {
		tight: { default: false },
		containTaskList: { default: false },
	},
};
